// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/components/feedback/EmptyState.jsx

import React from "react";
import ActionGroup from "../actions/ActionGroup";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function EmptyState({
  icon = null,
  title = "Nothing to show yet",
  description,
  actions = [],
  size = "default",
  className = "",
}) {
  return (
    <section
      className={joinClassNames(
        "oasys-empty-state",
        `oasys-empty-state--${size}`,
        className
      )}
    >
      {icon ? (
        <div className="oasys-empty-state__icon" aria-hidden="true">
          {icon}
        </div>
      ) : null}

      <div className="oasys-empty-state__content">
        <h3 className="oasys-empty-state__title">{title}</h3>

        {description ? (
          <p className="oasys-empty-state__description">{description}</p>
        ) : null}

        <ActionGroup
          actions={actions}
          align="center"
          className="oasys-empty-state__actions"
        />
      </div>
    </section>
  );
}
